import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import CONFIG from "@rentiohq/shared/dist/config/app.config";

export const Wrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const BackgroundImageLeftWrap = styled.div`
  display: none;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 100%;
  }
`;

export const BackgroundImageLeft = styled.img`
  flex: 1;
  height: 100%;
  margin-right: 375px;
  overflow: hidden;
  object-fit: cover;
  object-position: 100% 0;
`;

export const BackgroundImageRightWrap = styled.div`
  display: none;
  z-index: -1;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    display: flex;
    position: absolute;
    left: 50%;
    top: 0;
    width: 50%;
    height: 100%;
  }
`;

export const BackgroundImageRight = styled.img`
  flex: 1;
  height: 100%;
  margin-left: 375px;
  overflow: hidden;
  object-fit: cover;
  object-position: 0 0;
`;

export const CopyrightWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 4px;
  padding-bottom: 8px;
`;

export const RentioCopyrightLogo = styled.img`
  display: inline-block;
  width: 39px;
  height: 10px;
  margin-right: 4px;
`;

export const CopyrightYear = styled.span`
  color: ${props => props.theme.colors.neutral1};
  font-size: 10px;
  font-weight: bold;
  text-align: center;
`;

export const InnerWrap = styled.div`
  width: 100%;
  height: 100%;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin: 0 auto;
    max-width: 750px;
  }
`;

export const ContentWrap = styled.div<{ backgroundColor?: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  background-color: ${props =>
    props.backgroundColor || props.theme.colors.neutral2};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const RentioLogoWrap = styled.a`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 8px;
`;

export const RentioLogo = styled.img`
  width: 70px;
  height: 18px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    width: 100px;
    height: 26px;
  }
`;

export const ChildrenWrap = styled.div`
  position: relative;
  margin: 24px 0;
  flex: 1;
`;
